import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-gcse-classes',
    templateUrl: './gcse-classes.component.html',
    styleUrls: ['./gcse-classes.component.css'],
    standalone: false
})
export class GcseClassesComponent implements OnInit {

  constructor(private router: Router) {}

  // Flip states
  isLeftOpen = false;
  isRightOpen = false;

  // Gallery Section
  gal_images = [
    { src: 'assets/images/ps1.jpg',      title: 'Online Class Session' },
    { src: 'assets/images/gal_img1.jpg', title: 'Award Ceremony' },
    { src: 'assets/images/gal_img2.jpg', title: 'Exam Preparation' },
    { src: 'assets/images/gal_img3.jpg', title: 'Cultural Event' }
  ];

  currentIndex = 0;
  isSliding = false;

  get currentImage() {
    return this.gal_images[this.currentIndex].src;
  }

  get currentTitle() {
    return this.gal_images[this.currentIndex].title;
  }

  changeImage(index: number) {
    if (index !== this.currentIndex) {
      this.isSliding = true;
      setTimeout(() => {
        this.currentIndex = index;
        this.isSliding = false;
      }, 300);
    }
  }

  ngOnInit() {
    // Scroll reveal via IntersectionObserver (no HostListener needed)
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('gc-vis');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    setTimeout(() => {
      const els = document.querySelectorAll('.gc-reveal');
      els.forEach(el => observer.observe(el));
    }, 100);
  }


   bookFreeDemo() {
    window.open('https://go.sehyog.co.uk/FreeDemoForm', '_blank');
  }

}